import React from 'react';
import Link from 'next/link';
import clsx from 'clsx';
import styles from './StyledLink.module.css';
import type { StyledLinkProps } from './StyledLink.types';

export const StyledLink: React.FC<StyledLinkProps> = ({ href, children, variant = 'secondary', className = '', disabled = false, onClick }) => {
  const rootClass = clsx(
    styles.link,
    'p2 inline-flex items-center justify-center gap-8 rounded-sm px-[var(--padding-lr)] transition-colors underline',
    styles[variant],
    className,
    disabled && styles.disabled
  );

  return (
    <Link href={disabled ? '#' : href} className={rootClass} onClick={onClick}>
      {children}
    </Link>
  );
};
